import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "comment-list" }
const _hoisted_2 = {
  key: 0,
  class: "comment-list-loading"
}
const _hoisted_3 = { class: "comment-list-comments" }
const _hoisted_4 = { class: "comment-list-comment-meta" }
const _hoisted_5 = {
  key: 1,
  class: "comment-list-pagination"
}
const _hoisted_6 = ["onClick"]

import { Comment } from '@src/view_models/Comment';
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import ChevronLeftIcon from '@src/components/shared/icons/ChevronLeftIcon.vue';
import ChevronRightIcon from '@src/components/shared/icons/ChevronRightIcon.vue';
import LoadingSpinner from '@src/components/shared/LoadingSpinner.vue';
import { useCommentResource } from '@src/components/pages/useCommentResource';

const PAGE_SIZE = 10;


export default /*#__PURE__*/_defineComponent({
  __name: 'CommentList',
  setup(__props) {

const { t, n } = useI18n();

const { comments, fetchComments } = useCommentResource();
let pageContent = ref<Comment[]>( [] );
let pageCount = ref( 0 );
let currentPage = ref( 1 );
const isLoading = ref( true );

const isFirstPage = computed<boolean>( () => currentPage.value === 1 );
const isLastPage = computed<boolean>( () => currentPage.value === pageCount.value );

const switchPage = (): void => {
	pageContent.value = comments.value.slice(
		( currentPage.value - 1 ) * PAGE_SIZE,
		( currentPage.value * PAGE_SIZE ) - 1
	);
};

const nextPage = (): void => {
	if ( currentPage.value < pageCount.value ) {
		currentPage.value += 1;
		switchPage();
	}
};

const previousPage = (): void => {
	if ( currentPage.value > 1 ) {
		currentPage.value -= 1;
		switchPage();
	}
};

const goToPage = ( page: number ): void => {
	currentPage.value = page;
	switchPage();
};

const commentHeadline = ( comment: Comment ) => t(
	'donation_comments_donor_headline',
	{
		formattedAmount: n( Number( comment.amount ), { key: 'currency' } ),
		donor: comment.donor,
	}
);

onMounted( () => {
	fetchComments().then( () => {
		pageCount.value = Math.ceil( comments.value.length / PAGE_SIZE );
		switchPage();
		isLoading.value = false;
	} ).catch( () => {
		isLoading.value = false;
	} );
} );


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t( 'donation_comments_title' )), 1),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t( 'donation_comments_text' )), 1),
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createVNode(LoadingSpinner)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageContent), (comment) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "comment-list-comment",
          key: comment.date
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, _toDisplayString(commentHeadline( comment )), 1)
          ]),
          _createElementVNode("div", _hoisted_4, _toDisplayString(comment.date), 1),
          _createElementVNode("div", null, _toDisplayString(comment.comment), 1)
        ]))
      }), 128))
    ]),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("button", {
            class: _normalizeClass(["comment-list-previous", { 'inactive': isFirstPage.value }]),
            onClick: previousPage
          }, [
            _createVNode(ChevronLeftIcon)
          ], 2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageCount), (page) => {
            return (_openBlock(), _createElementBlock("button", {
              class: _normalizeClass(["comment-list-number", { 'current': _unref(currentPage) === page }]),
              key: page,
              onClick: () => goToPage( page )
            }, _toDisplayString(page), 11, _hoisted_6))
          }), 128)),
          _createElementVNode("button", {
            class: _normalizeClass(["comment-list-next", { 'inactive': isLastPage.value }]),
            onClick: nextPage
          }, [
            _createVNode(ChevronRightIcon)
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})